import { render, staticRenderFns } from "./SingleAccreditation.vue?vue&type=template&id=67967610&scoped=true&"
import script from "./SingleAccreditation.vue?vue&type=script&lang=js&"
export * from "./SingleAccreditation.vue?vue&type=script&lang=js&"
import style0 from "./SingleAccreditation.vue?vue&type=style&index=0&id=67967610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67967610",
  null
  
)

export default component.exports